export interface IFiltersUA {
  searchSelect: Set<string>;
  search: string;
  text: string;
  archetype: string;
  color: Set<string>;
  cost: Set<string>;
  energyCost: Set<string>;
  apCost: Set<string>;
  battlePower: Set<string>;
  cardType: Set<string>;
  showAAs: boolean;
  lang: Set<string>;
  format: Set<string>;
  set: string;
}

export default function getDefaultFilters(): IFiltersUA {
  return {
    searchSelect: new Set<string>(["name"]),
    search: "",
    text: "",
    archetype: "",
    format: new Set<string>(),
    color: new Set<string>(),
    cost: new Set<string>(),
    energyCost: new Set<string>(),
    apCost: new Set<string>(),
    battlePower: new Set<string>(),
    cardType: new Set<string>(),
    lang: new Set<string>(),
    showAAs: false,
    set: "",
  };
}
